import React from 'react';
import PropTypes from 'prop-types';
import { urlWithLocale } from '../../../utils/locale';

export function getCanonicalUrl({ country, pagePath, currentLocale }) {
  const {
    host: hostName,
    languages: [defaultLanguage],
  } = country;

  const canonicalLocale = currentLocale || defaultLanguage;
  const pagePathWithoutQueryStringOrLocale = pagePath
    .split('?')[0]
    .replace(`/${currentLocale}`, '');

  return `https://${hostName}${urlWithLocale(
    country,
    pagePathWithoutQueryStringOrLocale,
    canonicalLocale,
  )}`;
}

export default function RelCanonical({ country, pagePath, currentLocale }) {
  return <link rel="canonical" href={getCanonicalUrl({ country, pagePath, currentLocale })} />;
}

RelCanonical.defaultProps = {
  currentLocale: undefined,
};

RelCanonical.propTypes = {
  pagePath: PropTypes.string.isRequired,
  country: PropTypes.shape({
    host: PropTypes.string.isRequired,
    languages: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  }).isRequired,
  currentLocale: PropTypes.string,
};
